import memoizeOne from 'memoize-one';
import { cascadingSelectClipboardHandler } from '../field-types/cascading-select/clipboard-handler';
import { categoryClipboardHandler } from '../field-types/category/clipboard-handler';
import { checkboxClipboardHandler } from '../field-types/checkbox/clipboard-handler';
import { componentsClipboardHandler } from '../field-types/components/clipboard-handler';
import { dateClipboardHandler } from '../field-types/date/clipboard-handler';
import { dateTimeClipboardHandler } from '../field-types/datetime/clipboard-handler';
import { groupClipboardHandler } from '../field-types/group/clipboard-handler';
import { labelsClipboardHandler } from '../field-types/labels/clipboard-handler';
import { multiSelectClipboardHandler } from '../field-types/multi-select/clipboard-handler';
import { numberClipboardHandler } from '../field-types/number/clipboard-handler';
import { parentClipboardHandler } from '../field-types/parent/clipboard-handler';
import { priorityClipboardHandler } from '../field-types/priority/clipboard-handler';
import { projectClipboardHandler } from '../field-types/project/clipboard-handler';
import { radioSelectClipboardHandler } from '../field-types/radio-select/clipboard-handler';
import { richTextClipboardHandler } from '../field-types/rich-text/clipboard-handler';
import { singleSelectClipboardHandler } from '../field-types/single-select/clipboard-handler';
import { sprintClipboardHandler } from '../field-types/sprint/clipboard-handler';
import { teamClipboardHandler } from '../field-types/team/clipboard-handler';
import { textClipboardHandler } from '../field-types/text/clipboard-handler';
import { timeTrackingClipboardHandler } from '../field-types/time-tracking/clipboard-handler';
import { urlClipboardHandler } from '../field-types/url/clipboard-handler';
import {
	userClipboardHandler,
	multiUserClipboardHandler,
} from '../field-types/user/clipboard-handler';
import { versionClipboardHandler } from '../field-types/version/clipboard-handler';

const createClipboardHandlers = memoizeOne(() => ({
	...categoryClipboardHandler,
	...checkboxClipboardHandler,
	...componentsClipboardHandler,
	...versionClipboardHandler,
	...labelsClipboardHandler,
	...numberClipboardHandler,
	...userClipboardHandler,
	...multiUserClipboardHandler,
	...multiSelectClipboardHandler,
	...dateClipboardHandler,
	...dateTimeClipboardHandler,
	...textClipboardHandler,
	...richTextClipboardHandler,
	...priorityClipboardHandler,
	...singleSelectClipboardHandler,
	...sprintClipboardHandler,
	...timeTrackingClipboardHandler,
	...urlClipboardHandler,
	...teamClipboardHandler,
	...parentClipboardHandler,
	...groupClipboardHandler,
	...projectClipboardHandler,
	...cascadingSelectClipboardHandler,
	...radioSelectClipboardHandler,
}));

export const getClipboardHandlerComponent = (
	fieldType: keyof ReturnType<typeof createClipboardHandlers> | undefined,
) => {
	const handlers = createClipboardHandlers();

	if (!fieldType || handlers[fieldType] == null) {
		return;
	}

	return handlers[fieldType];
};
